import React from 'react';
import WebSocketControl from './websocket';
import store from '../store';
import {
  TEST_WEBSOCKET,
  CHANGE_SESSION,
  CHANGE_DOCUMENT,
  CLOSE_DOCUMENT,
  CHANGE_ACTIVITY,
  REGISTERED,
  USER_JOINED,
  USER_LEFT,
  SESSION_CHANGED,
  DOCUMENT_CHANGED,
  DOCUMENT_CLOSED,
  ACTIVITY_CHANGED,
} from '../constants';
// TODO: find a better way to dispatch
import { registered, userJoinedWebsockets, userLeftWebsockets, sessionChanged, documentChanged, documentClosed, activityChanged } from '../actions';


interface WebSocketServiceProps {
  userId: string;
  sessionId: string;
}

interface WebSocketServiceState {
}

export default class WebSocketService extends React.Component <WebSocketServiceProps, WebSocketServiceState> {

  private webSocketControl: WebSocketControl;
  private url: string;
  private sessionId: string;
  private userId: string;
  private store: any;

  constructor(props: WebSocketServiceProps) {
    super(props);
    this.userId = this.props.userId;
    this.sessionId = this.props.sessionId;
    this.url = process.env.REACT_APP_WEBSOCKET_URL + ':' + process.env.REACT_APP_WEBSOCKET_PORT || '';
    console.error('Connecting to Websocket URL: ' + this.url);
    this.store = store;
    this.webSocketControl = new WebSocketControl(this.url, this.sessionId, this.userId);

    this.webSocketControl.on(REGISTERED, this.onRegistered);
    this.webSocketControl.on(SESSION_CHANGED, this.onSessionChanged);
    this.webSocketControl.on(DOCUMENT_CHANGED, this.onDocumentChanged);
    this.webSocketControl.on(ACTIVITY_CHANGED, this.onActivityChanged);
    this.webSocketControl.on(USER_JOINED, this.onUserJoined);
    this.webSocketControl.on(USER_LEFT, this.onUserLeft);
    this.webSocketControl.on(DOCUMENT_CLOSED, this.onDocumentClosed);
  }

  public destroy = () => {
    this.webSocketControl.disconnect();
  }

  public testWebsocket = (message: string) => {
    this.webSocketControl.emit(TEST_WEBSOCKET, {userId: this.userId, message: message});
  }

  public changeSession = (oldSessionId: string, newSessionId: string) => {
    console.log('Changing session to ' + newSessionId);
    this.webSocketControl.emit(CHANGE_SESSION, {userId: this.userId, oldSessionId: oldSessionId, newSessionId: newSessionId});
  }

  public changeDocument = (documentId: string) => {
    this.webSocketControl.emit(CHANGE_DOCUMENT, {userId: this.userId, documentId: documentId});
  }

  public closeDocument = () => {
    this.webSocketControl.emit(CLOSE_DOCUMENT, {userId: this.userId});
  }

  public changeActivity = (activityType: string) => {
    console.log('about to change activity type to ' + activityType);
    this.webSocketControl.emit(CHANGE_ACTIVITY, {userId: this.userId, sessionId: this.sessionId, activityType: activityType});
  }

  private onRegistered = (payload: any) => {
    const { userId, sessionId } = payload;
    return store.dispatch(registered(userId, sessionId));
  }

  private onUserJoined = (payload: any) => {
    const { userId, sessionId } = payload;
    return store.dispatch(userJoinedWebsockets(userId, sessionId));
  }

  private onUserLeft = (payload: any) => {
    const {userId, sessionId } = payload;
    return store.dispatch(userLeftWebsockets(userId, sessionId));
  }

  private onDocumentChanged = (payload: any) => {
    const { userId, documentId } = payload;
    return store.dispatch(documentChanged(userId, documentId));
  }

  private onDocumentClosed = (payload: any) => {
    const { userId } = payload;
    console.log('a user has closed the active document');
    return store.dispatch(documentClosed(userId));
  }

  // TODO: Wire these up to allow switching from one room to another
  private onSessionChanged = (payload: any) => {
    const { userId, oldSessionId, newSessionId } = payload;
    console.log('the session has been changed by remote user ' + userId);
    console.log('with old sessionId ' + oldSessionId);
    console.log('with new sessionId ' + newSessionId);
    return store.dispatch(sessionChanged(userId, oldSessionId, newSessionId));
  }

  private onActivityChanged = (payload: any) => {
    const { userId, sessionId, activityType } = payload;
    console.log('user ' + userId + ' in session ' + sessionId);
    console.log('changed the activity to ' + activityType);
    // TODO: Add documentId here?
    return store.dispatch(activityChanged(userId, sessionId, activityType));
  }

}